import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'ngx-submit-popover-layout',
    templateUrl: './submit-popover-layout.component.html',
    styleUrls: ['./submit-popover-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubmitPopoverLayoutComponent {
    @Input() submitBtnLabel: string = 'Apply';
    @Input() disableSubmit: boolean = false;
    @Output() applyClicked = new EventEmitter<void>();

    apply(): void {
        this.applyClicked.emit();
    }
}
